import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';

import 'flickity-imagesloaded';
import 'van11y-accessible-tab-panel-aria';
import ProductCard from '../components/product-card';
import {updateOffscreenPanelVisibility} from '../utils/a11y';

export default register('featured-collection', {
  onLoad() {
    const sliders = this.container.querySelectorAll('.featured-collection__slider');
    if (sliders.length === 0) return;
    const productCards = this.container.querySelectorAll('.product-card');
    if (productCards.length > 0) {
      productCards.forEach((product) => ProductCard(product));
    }
    sliders.forEach((slider) => {
      const slides = slider.querySelectorAll('.slide');
      // eslint-disable-next-line no-unused-vars
      const flickity = new Flickity(slider, {
        // options
        draggable: true,
        freeScroll: false,
        prevNextButtons: true,
        pageDots: true,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        watchCSS: true,
        contain: true,
        groupCells: true,
        arrowShape: 'm12.075 51.432 27.04 23.66L36.572 78 4 49.5 36.571 21l2.545 2.908-27.04 23.66H95.8v3.864H12.075Z',
        on: {
          ready() {
            updateOffscreenPanelVisibility(slides);
          },
          change() {
            updateOffscreenPanelVisibility(slides);
          },
        },
      });
    });

    // Event listener when tab links are clicked
    document.querySelectorAll('.js-tablist__link').forEach((link) => {
      link.addEventListener('click', () => {
        const tabID = link.getAttribute('aria-controls');
        const tab = document.querySelector(`#${tabID}`);
        // Resize and update flickity slider
        const slider = tab.querySelector('.featured-collection__slider');
        if (slider === null) return;
        const flickity = Flickity.data(slider);
        flickity.resize();
      });
    });
  },
});
